export default __webpack_public_path__ + "static/media/sort.ba45373a.svg";